// extracted by mini-css-extract-plugin
export default {"div":"Info_div__JMC4g","map":"Info_map__6EJ1p"};